import { MainContent } from "./components/dashboard/MainContent";
import Layout from "./components/ui/Layout";

export const Dashboard = () => {
  return (
    <Layout>
      <MainContent />
    </Layout>
  );
};
